export enum TabQSParam {
  APPROVED = 'approved',
  DONE = 'done',
  GROUPED = 'grouped',
  INVOICES = 'invoices',
  PENDING = 'pending',
  SENT = 'sent',
  SETTLEMENTS = 'settlements',
}
